import { Dropdown, Icon, Modal, PrimaryButton, Shimmer, ShimmerElementType, TextField } from "@fluentui/react";
import React, { useEffect, useState, useContext, useRef } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import themeContext from "../../../../../context/theme/ThemeContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import toastContext from "../../../../../context/toast/ToastContext";
import { REPORT_TITLE, SHOW_NOT_ORIGNAL_MODALITY_LIST, TOAST_TYPE } from "../../../../../constants/Constants";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import ExternalReporting from "../ExternalReporting/ExternalReporting";
import CustomEditor from "../../../../Report/components/CustomEditorSection/CustomEditor";
import FroalaEditor from "react-froala-wysiwyg";
import RBadge from "../../../../../components/SVGComponents/RBadge";
import PBadge from "../../../../../components/SVGComponents/PBadge";
import DBadge from "../../../../../components/SVGComponents/DBadge";
import LBadge from "../../../../../components/SVGComponents/LBadge";
import CLBadge from "../../../../../components/SVGComponents/CLBadge";
import ShimmerStudyRows from "../../ShimmerStudyList/ShimmerStudyRows";
import LoadingBar from "react-top-loading-bar";
import { getFormattedReport, saveReportTemplatesData } from "../../../../../service/StudyReportService";
import ClippedKeyImageRow from "../../../../StudyViewer/Components/ClippedKeyImagesModal/ClippedKeyImageRow"; //ClippedKeyImagesModal/ClippedKeyImagesModal";
import { getClippedKeyImagesAPI, updateClippedKeyImagesAPI, generateUSGLLMReportGenerator } from "../../../../../service/StudyViewerService"; //'../../../../service/StudyViewerService';
import userContext from '../../../../../context/users/UserContext';

const DEEPGRAM_API_URL = process.env.REACT_APP_DEEPGRAM_API_URL;
const DEEPGRAM_API_KEY = process.env.REACT_APP_DEEPGRAM_API_KEY;

const FormatterAgentClippedModal = (props) => {
 
  const [formatterLoading, setFormatterLoading] = useState(false);
  const [t] = useTranslation();
  const { showToastv2 } = useContext(toastContext);
  const [editReport, setEditReport] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [isFormattedView, setIsFormattedView] = useState(false);
  const editorRef = useRef(null);
  const [currentActiveTab, setCurrentActiveTab] = useState("");
  const [model, setModel] = useState("");
  const { themeName } = useContext(themeContext);
  const { studyId, patientReports, allReportTemplates, setPatientReports, showFormatterPopupClipped, setShowFormatterPopupClipped, setPendingSubmission, setFormattedReportAction, setPendingQCPass, clippedKeyImagesData, setClippedKeyImagesData, previewClippedKeyImageBase64, setPreviewClippedKeyImageBase64, setAlertSuccessModal, alertSuccessModal, handleSaveReport, handleSubmitReport } = useContext(studyReportContext);
  const { roles } = useContext(userContext);
  const [updatedReports, setUpdatedReports] = useState([]);
  const [errorState, setErrorState] = useState(null);
  const [showManageClippedKeyImagesModal, setShowManageClippedKeyImagesModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [isSubmitSaveDisabled, setIsSubmitSaveDisabled] = useState(true);
  const [promptText, setPromptText] = useState("");
  const [skipImages, setSkipImages] = useState(false);
  const [clippedKeyImagesDataCount, setClippedKeyImagesDataCount] = useState([]);
  const [isSendButtHovering, setIsSendButtHovering] = useState(false);
  const [isSideViewToggleEnable, setSideViewToggleEnable] = useState(true);
  const textareaPromptRef = useRef(null);
  const mediaStreamRef = useRef(null);
  const webSocketRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const keepAliveRef = useRef(null);
  const [isMicButtHovering, setIsMicButtHovering] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isEraserButtHovering, setIsEraserButtHovering] = useState(false);

  useEffect(() => {
    // setIsFormattedView(false);
    console.log("studyid of clipped key images------", studyId);
    getClippedKeyImages(studyId);
  }, []);


  useEffect(() => {
    setClippedKeyImagesDataCount(clippedKeyImagesData.filter((e) => e.enabled === true).length);
  }, [clippedKeyImagesData]);

  useEffect(() => {
    let opt = [];
    let blankTemplate = allReportTemplates.reportTemplates[0];
    setCurrentActiveTab(blankTemplate.title);
    opt.push({ key: blankTemplate.id, text: blankTemplate.title, reportDetails: blankTemplate });
    setUpdatedReports(opt);
  }, []);

  const handleModelChange = (model) => {
    console.log("-- HandleModelChange ---", model);
    if (isFormattedView) {
      setUpdatedReports((prevReports) =>
        prevReports.map((ele) => {
          if (currentActiveTab === ele.text) {
            let tempReportDetails = ele.reportDetails ?? { report: ele.report };

            if (tempReportDetails.report === undefined) {
              tempReportDetails.finalReport = model;
            } else {
              tempReportDetails.report = model;
            }

            return { ...ele, reportDetails: tempReportDetails };
          }
          return ele;
        })
      );
    }
    setModel(model);
  };

  const handleSaveLLMReport = () => {
   // replaceReportContent();
    setPatientReports(updatedReports);
    setFormattedReportAction("SAVE");
    handleSaveReport(
      true,
      props.keyImages,
      props.annotationData,
      props.annotationDataAI,
      props.allTextToolAnnotation,
      props.activeViewportIndex,
      null,
      "SAVE",
      updatedReports
    )
  }

  const handleSubmitLLMReport = () => {
    setFormattedReportAction("SUBMIT");
    //replaceReportContent();
    setPatientReports(updatedReports);
    setShowFormatterPopupClipped(false);
    handleSubmitReport(
      true,
      props.keyImages,
      props.annotationData,
      props.annotationDataAI,
      props.allTextToolAnnotation,
      props.activeViewportIndex,
      false, false, false, "SUBMIT", updatedReports
    )
  }

  const handlePromptTextareaInputChange = (e) => {

    const el = textareaPromptRef.current;
    if (el) {
      el.style.height = "auto"; // Reset to recalculate
      el.style.height = Math.min(el.scrollHeight, 72) + "px"; // 4 rows * 18px
      el.style.overflowY = el.scrollHeight > 72 ? "auto" : "hidden";
    }
    setPromptText(e.target.value);
  };

  const handlePromptTextareaFocus = () => {
    const el = textareaPromptRef.current;
    if (el) {
      el.style.transition = "0.8s ease";
      el.style.height = Math.min(el.scrollHeight, 72) + "px";
      el.style.overflowY = el.scrollHeight > 72 ? "auto" : "hidden";
    }
  };

  const handlePromptTextareaBlur = () => {
    const el = textareaPromptRef.current;
    if (el) {
      el.style.transition = "0.8s ease";
      el.style.height = "36px"; // 1 row ( 36px line height)
      el.style.overflowY = "hidden";
    }
  };

  const getClippedKeyImages = async (studyId) => {
    setLoading(true);
    try {
      let response = await getClippedKeyImagesAPI(studyId);
      console.log("response of clipped key images", response);
      setClippedKeyImagesData(response.data.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      //props.setShowManageClippedKeyImagesModal(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = true;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = "Error while fetching Clipped images";
        return newItem;
      });
    }
  }


  const handleFormatterStart = async (studyId) => {
    setFormatterLoading(true); //return false;
    try {
      let response = await generateUSGLLMReportGenerator(studyId, promptText, clippedKeyImagesData, skipImages);
      console.log("generateUSGLLMReportGenerator Response:", JSON.stringify(response.data.data, null, 2));
      
      const { output, error } = response.data.data;
      setFormatterLoading(false);

      if (output) {
        let reportHtml = output.replace(/```html|```/g, '');
        setModel(reportHtml + "<br><br><br><br><br><br><br>");
        setIsFormattedView(true);
        setIsSubmitSaveDisabled(false);
      } else if (error) {
        setAlertSuccessModal(() => ({
          ...alertSuccessModal,
          show: true,
          heading: "Alert",
          isError: true,
          isSuccess: false,
          isWarning: true,
          description: error || "An unknown error occurred while fetching the report.",
        }));
      }

    } catch (e) {
      setLoading(false);
      setFormatterLoading(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = true;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = "Error while fetching Report";
        return newItem;
      });
    }
  }

  const insertTextRef = useRef((text) => {
    setPromptText(prev => prev + (prev && !prev.endsWith(" ") ? " " : "") + text);
  });

  const resetSilenceTimer = () => {
    // Optionally implement auto-stop if silence detected
  };

  const stopRecording = () => {
    setIsRecording(false);

    if (mediaRecorderRef.current?.state === "recording") {
      mediaRecorderRef.current.stop();
    }

    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach(track => track.stop());
      mediaStreamRef.current = null;
    }

    if (webSocketRef.current) {
      webSocketRef.current.close();
      webSocketRef.current = null;
    }

    if (keepAliveRef.current) {
      clearInterval(keepAliveRef.current);
      keepAliveRef.current = null;
    }
  };

  const startRecording = async () => {
    if (isRecording) return;

    try {
      const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaStreamRef.current = audioStream;
      const mediaRecorder = new MediaRecorder(audioStream);
      mediaRecorderRef.current = mediaRecorder;

      const ws = new WebSocket(DEEPGRAM_API_URL, ["token", DEEPGRAM_API_KEY]);
      webSocketRef.current = ws;

      ws.onopen = () => {
        mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0 && ws.readyState === WebSocket.OPEN) {
            ws.send(event.data);
          }
        };
        mediaRecorder.start(250);

        keepAliveRef.current = setInterval(() => {
          ws.send(JSON.stringify({ type: "KeepAlive" }));
        }, 3000);
      };

      ws.onmessage = (message) => {
        const data = JSON.parse(message.data);
        const transcript = data?.channel?.alternatives?.[0]?.transcript;
        if (transcript && data.is_final) {
          insertTextRef.current(transcript);
          resetSilenceTimer();
        }
      };

      ws.onclose = () => stopRecording();
      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        stopRecording();
      };

      setIsRecording(true);
      resetSilenceTimer();

      // Ensure textarea is focused to get correct cursor position
      textareaPromptRef.current?.focus();
    } catch (error) {
      console.error("Mic permission denied or error:", error);
      let message = "Something went Wrong.";
      if (error.name === "NotAllowedError" || error.name === "SecurityError") {
        message = `Microphone access denied.
          \nPlease enable microphone permission in your browser settings:
          \n- Chrome: Click the padlock icon near the URL bar > "Site settings" > Set "Microphone" to "Allow".
          \n- Firefox: Click the padlock icon > "Permissions" > "Microphone" > "Allow".
          \n- Safari: Safari > Settings for This Website > Enable Microphone.
      `;
      } else {
        message = "Unable to access microphone. Please check your device settings.";
      }
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = true;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = message;
        return newItem;
      });
    }
  };


  const toggleRecording = () => {
    isRecording ? stopRecording() : startRecording();
  };

  useEffect(() => {
    return () => stopRecording(); // Cleanup on unmount
  }, []);

  useEffect(() => {

     insertTextRef.current = (transcript) => {
      const textarea = textareaPromptRef.current;
      if (!textarea) return;

      const currentValue = textarea.value;
      const selectionStart = textarea.selectionStart;
      const selectionEnd = textarea.selectionEnd;

      let updatedText;
      let cursorPositionAfterInsert;

      if (selectionStart !== null && selectionEnd !== null && selectionStart !== selectionEnd) {
        // Text is selected — insert after selected text
        const before = currentValue.slice(0, selectionEnd);
        const after = currentValue.slice(selectionEnd);
        updatedText = before + " " + transcript + " " + after;
        cursorPositionAfterInsert = selectionEnd + transcript.length + 2;
      } else if (selectionStart !== null) {
        // Cursor exists — insert at cursor
        const before = currentValue.slice(0, selectionStart);
        const after = currentValue.slice(selectionStart);
        updatedText = before + " " + transcript + " " + after;
        cursorPositionAfterInsert = selectionStart + transcript.length + 2;
      } else {
        // Fallback: append to end
        updatedText = currentValue + " " + transcript + " ";
        cursorPositionAfterInsert = updatedText.length;
      }

      // Update state
      setPromptText(updatedText);

      // Wait for state update, then restore cursor
      requestAnimationFrame(() => {
        textarea.focus();
        textarea.selectionStart = textarea.selectionEnd = cursorPositionAfterInsert;
        requestAnimationFrame(() => {
            // Auto-resize logic like in manual input
            textarea.style.height = "auto";
            textarea.style.height = Math.min(textarea.scrollHeight, 72) + "px";
            textarea.style.overflowY = textarea.scrollHeight > 72 ? "auto" : "hidden";

            // Scroll to keep the cursor in view
            const { selectionStart } = textarea;
            const lineHeight = 18; // approx line height in px (adjust if needed)

            const topOffset = textarea.scrollHeight * (selectionStart / textarea.value.length);
            textarea.scrollTop = topOffset - lineHeight;
          });
      });
    };

  }, []);

  let DefaultButtonList = [
    {
      title: "Save",
      onclick: () => handleSaveLLMReport(),
      disabled: isSubmitSaveDisabled || (formatterLoading && errorState == null)
    },
  ];

  let PrimaryButtonList = [
    {
      title: "Submit",
      onclick: () => handleSubmitLLMReport(),
      disabled: isSubmitSaveDisabled || (formatterLoading && errorState == null)
    },
  ];

  let ToggleViewButton = [
    {
      title: "Panel",
      onclick: () => isSideViewToggleEnable ? setSideViewToggleEnable(false) : setSideViewToggleEnable(true)
    },
  ];
  const handleCancel = () => {
    setShowFormatterPopupClipped(false);
  }


  const getConfig = (formattedView) => ({
    placeholderText: "Edit Your Content Here!",
    key: process.env.REACT_APP_FROALA_API_KEY,
    attribution: false,
    charCounterCount: false,
    height: 469,
    width: 818,
    fontSize: [
      "8", "9", "10", "10.67", "11", "12", "13", "13.33", "14", "14.67", "15",
      "16", "17", "17.33", "18", "18.67", "19", "21.33", "24", "30", "36", "48", "60", "72", "96"
    ],
    fontSizeDefault: "12",
    fontSizeUnit: "px",
    lineHeights: { Default: "1.5", Single: "1", 1.15: "1.15", 1.5: "1.5", Double: "2" },
    fontFamilyDefaultSelection: "Times New Roman, serif",
    paste: formattedView,
    pastePlain: formattedView,
    pasteAllowedStyleProps: [],
    wordPasteModal: false,
    pluginsEnabled: [
      "fullscreen", "codeBeautifier", "colors", "fontFamily", "lineHeight",
      "fontSize", "paragraphFormat", "paragraphStyle", "align", "lists", "table"
    ],
    toolbarButtons: {
      moreText: {
        buttons: [
          "undo", "redo", "|", "paragraphFormat", "lineHeight", "|", "fontFamily", "|",
          "fontSize", "|", "bold", "italic", "underline", "|", "fullscreen", "|",
          "formatOL", "formatUL", "strikeThrough", "clearFormatting", "|", "textColor",
          "backgroundColor", "|", "alignLeft", "alignCenter", "alignRight",
          "alignJustify", "outdent", "indent", "|", "insertTable", "|", "copy"
        ],
        align: "left",
        buttonsVisible: 12,
      },
    },
    events: formattedView
      ? {}
      : {
        initialized: function () {
          console.log("-- initializing Froala in read-only mode");
          this.edit.off();
        },
      },
  });

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={<>
          <Icon iconName="AutoEnhanceOn" style={{ marginRight: "10px" }} />
          {t("clipped-key-images.manage-key-image")}
        </>}
        handleCancel={() => handleCancel()}
      />
    ),
    body: (<>
      <div style={{ display: "flex" }}>

        <div style={{
          display: "flex",
          flexDirection: "column",

          // display: isSideViewToggleEnable ? "" : "none",
          overflow: "hidden",
          width: isSideViewToggleEnable ? "250px" : "0px",
          height: "553px",
          transition: "width 0.3s ease",
          opacity: isSideViewToggleEnable ? 1 : 0,
          pointerEvents: isSideViewToggleEnable ? "auto" : "none",
          //paddingBottom:"10px",
          boxSizing: "border-box",
          borderRight: "1px solid gray",
          //  borderBottom: "1px solid #e2dddd"


        }}>
          {/* Top content with max width */}
          <div style={{ flex: 1, width: "240px", marginBottom: "0px", padding: "10px", paddingBottom: "0px" }}>
            {loading ? (
              <div
                style={{
                  padding: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",

                  maxHeight: "364px", height: "364px"
                }}
              >
                <Spinner size={SpinnerSize.large} />
              </div>
            ) :
              <div className='custom-modal-scroll' style={{ maxHeight: "364px", height: "364px", overflowY: "auto" }}>
                {clippedKeyImagesData.length > 0 ? (
                  <>
                    <div>
                      <div
                        style={{
                          /*   display: "flex",
                             flexDirection: "column",
                             alignItems: "center",
                             justifyContent: "center", */
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          width: "100%",
                        }}
                      >
                        {clippedKeyImagesData?.map((keyImage, index) => {
                          return (
                            <React.Fragment key={index}>
                              <ClippedKeyImageRow
                                keyImage={keyImage}
                                setClippedKeyImagesData={setClippedKeyImagesData}
                                clippedKeyImagesData={clippedKeyImagesData}
                                studyId={props.activeStudyId}
                                index={index}
                                roles={roles}
                              />
                            </React.Fragment>
                          );
                        })}
                      </div>

                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ marginLeft: "0px", color: "white" }}>
                        {" "}
                        {t("clipped-key-images.no-key-images")}
                      </span>
                    </div>
                  </>
                )}
              </div>
            }
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between", // splits left & right
              alignItems: "center",
              padding: "10px",
              backgroundColor: "#0f1927"

            }}
          >
            <label style={{ display: "flex", alignItems: "center", gap: "px" }}>
              <input
                type="checkbox"
                checked={skipImages}
                onChange={(e) => setSkipImages(e.target.checked)}
              />
              Skip Images
            </label>


            <div>{clippedKeyImagesDataCount} / {clippedKeyImagesData.length} Selected</div>
          </div>


          <div
            style={{
              display: "flex",
              padding: "10px 10px 10px 10px",
              paddingTop: "0px",
            }}
          >

            {!previewClippedKeyImageBase64 ? (
              <div
                style={{
                  width: "241px",
                  height: "125px",
                  objectFit: "cover",
                  borderRadius: 4,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#e2dddd",
                  color: "#666",
                  fontSize: "14px",
                }}
              >
                Preview Not Available
              </div>
            ) : (
              <img
                src={"data:image/jpeg;base64," + previewClippedKeyImageBase64}
                style={{
                  width: "240px",
                  height: "123px",
                  // objectFit: "fit",
                  borderRadius: 4,
                  // border: "1px solid #e2dddd",
                }}
              />
            )}

            {/*}
<textarea
  rows={4}
  placeholder="Enter Prompt"
  className="custom-textarea"
  value={promptText}
  onChange={(e) => setPromptText(e.target.value)}
/> */}


          </div>

          {/*}
  <PrimaryButton
    onClick={() => handleFormatterStart(studyId)}
    text="Generate Report"
    style={{
      fontSize: "12px",
      fontWeight: "400",
      padding: "5px 10px",
      color: "white",
    }}
  /> */}
        </div>


        <div style={{ flex: 3 }}>
          <div className="report-container" style={{ filter: "unset", position: "relative" }}>

            <>

              <div
                style={{
                  //   borderBottom: "1px solid #e2dddd",
                  display: "flex",
                  flexDirection: "column",
                  //height: "70px",
                  boxSizing: "border-box",
                  // paddingTop: "10px"

                }}>
                <AddTab data={isFormattedView ? updatedReports : patientReports} setActiveTabIndex={setActiveTabIndex} activeTabIndex={activeTabIndex} />
              </div>
              <div style={{ /*borderBottom: "1px solid #e2dddd",*/ paddingBottom: "10px", paddingLeft: "10px", paddingRight: "3px", paddingTop: "10px", height: "553px", boxSizing: "border-box", position: "relative" }}>

                {formatterLoading ? <div style={{ borderRadius: 15, border: "1px solid #e2dddd", overflow: "hidden", width: "99%" }}>
                  {errorState == null ?
                    <Shimmer
                      shimmerElements={[{ type: ShimmerElementType.line, height: 530, width: 815 }]}
                      shimmerColors={{
                        background: themeName != "light" ? "#040910" : "white",
                        // shimmer: "#2948ff",   // Bluish shimmer
                        // shimmerWave: "#1a1a1a", // Dark background
                        // background: "#000000",  // Black base

                        background: "#f5f5f5",     // Light gray background
                        shimmer: "#e0e0e0",        // Lighter gray shimmer
                        shimmerWave: "#d0d0d0"     // Even lighter wave
                      }}
                      style={{ /* position: "absolute", top: 0, */ left: 0, width: "100%", height: "99%" }}
                    />
                    : (
                      <div
                        style={{
                          backgroundColor: themeName !== "light" ? "#040910" : "white",
                          width: "818px",
                          height: "429px",
                        }}
                      />
                    )}

                  <div style={{
                    position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                    fontSize: "18px", color: "#676262" /*"#bfbfbf"*/, zIndex: 10
                  }}>{errorState?.message ? errorState.message : "🪄 Report generation in progress"}
                  </div>
                </div> :

                  <FroalaEditor
                    tag="textarea"
                    config={getConfig(isFormattedView)}
                    model={model}
                    ref={editorRef}
                    key={`${editReport.toString()}-${isFormattedView}`}
                    onModelChange={(val) => handleModelChange(val)}
                  />

                }

                {/** prompt box **/}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "15px 0px",
                  //hide backgroundColor: "white",
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                  position: "relative",
                  width: "99%",
                }}>
                  <div style={{
                    position: "absolute",
                    // display: "flex",
                    flex: "1 1 0%",
                    flexDirection: "column",
                    left: "0",
                    right: "15px",
                    bottom: "45px",
                    zIndex: 10,
                    margin: "10px",
                    border: "1px solid #e2dddd",
                    padding: "10px",
                    borderRadius: "15px",
                    boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px ,rgba(0, 0, 0, 0.24) 0px 1px 2px",
                    backgroundColor: "white",
                    marginBottom: 0,
                    marginRight: 0

                  }}>
                
                    {/* Textarea */}
                    <textarea
                      ref={textareaPromptRef}
                      onChange={handlePromptTextareaInputChange}
                      onFocus={handlePromptTextareaFocus}
                      onBlur={handlePromptTextareaBlur}
                      rows={1}
                      placeholder={t("clipped-key-images.prompt-msg")}
                      className={`custom-textarea ${isRecording ? "recording" : ""}`}

                      style={{
                        bottom: "36px",
                        left: "0px",
                        right: "0px",
                        fontSize: "14px",
                        padding: "5px",
                        resize: "none",
                        outline: "none",
                        //overflowY: "auto",
                        zIndex: 10,
                        transition: "0.8s",
                        height: "36px",
                        border: "0px",

                      }}
                      value={promptText}
                    />


                    {/* Mic icon on the left */}
                    <div style={{
                      display: "flex",
                      //  marginRight: "5px",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                    >

                      <span
                        onClick={() => setPromptText("")}
                        title="Clear Instructions"
                        onMouseEnter={() => setIsEraserButtHovering(true)}
                        onMouseLeave={() => setIsEraserButtHovering(false)}
                        style={{
                          display: "inline-block",
                          height: "30px",
                          width: "30px",
                          cursor: "pointer",
                          backgroundColor: isEraserButtHovering ? "#f0f0f0" : "transparent",
                          border: "1px solid #5d5d5d",
                          borderRadius: "35px",
                          marginRight: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill={"#5d5d5d"}>
                          <path d="M16.24 3.56a2 2 0 0 1 2.83 0l1.37 1.37a2 2 0 0 1 0 2.83l-9.9 9.9a2 2 0 0 1-1.41.59H6a1 1 0 0 1-1-1v-2.12c0-.53.21-1.04.59-1.41l9.9-9.9zM5 19h14a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2z"/>
                        </svg>
                      </span>

                      <span
                        onClick={toggleRecording}
                        onMouseEnter={() => setIsMicButtHovering(true)}
                        onMouseLeave={() => setIsMicButtHovering(false)}
                        title={isRecording ? "Stop" : "Dictate"}
                        style={{ 
                          display: "inline-block", 
                          height: "30px", 
                          cursor: "pointer",
                          backgroundColor: isMicButtHovering || isRecording ? "#f0f0f0" : "transparent",
                          border: "0px solid",
                          borderColor: isRecording ? "red" : "#5d5d5d",
                          borderRadius: "35px",
                          // width: "30px",
                          // height: "30px",
                          // padding: "4px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          transition: "all 0.2s ease-in-out", }}
                      >

                      {isRecording ? (
                          // Stop icon
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="red" style={{
                          borderColor: "#5d5d5d",
                          backgroundColor: isMicButtHovering || isRecording ? "#f0f0f0" : "transparent",
                          color: "rgb(93, 93, 93)",
                          borderColor: "#5d5d5d",
                          // color: "#5d5d5d",
                          border: "1px solid",
                          borderRadius: "35px",
                          width: "20px",
                          height: "20px",
                          padding: "5px",
                          // background: isRecording ? "radial-gradient(circle, rgb(255 0 56), rgb(255 0 68))" : "",
                          animation: isRecording ? "pulseCircle 1.5s infinite" : "",
                          zIndex: 0,
                        }} xmlns="http://www.w3.org/2000/svg">
                            <rect x="6" y="6" width="12" height="12" rx="2" />
                          </svg>
                        ) : (
                          // Mic icon
                          <svg width="24" fill={"#5d5d5d"} style={{
                          borderColor: "#5d5d5d",
                          backgroundColor: isMicButtHovering ? "#f0f0f0" : "transparent",//isMicButtHovering ? "#0a0000" : "transparent", 
                          color: "rgb(93, 93, 93)", 
                          borderColor: "#5d5d5d",
                          // color: "#5d5d5d",
                          border: "1px solid",
                          borderRadius: "35px",
                          width: "20px",
                          height: "20px",
                          padding: "5px",
                          zIndex: 0,
                        }} height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Mic icon" class="h-[18px] w-[18px]" font-size="inherit"><path d="M18.9953 11.5415C19.5246 11.6991 19.826 12.2559 19.6685 12.7852C18.7771 15.7804 16.179 18.0417 13 18.4381V19.5H14.5C15.0523 19.5 15.5 19.9477 15.5 20.5C15.5 21.0523 15.0523 21.5 14.5 21.5H9.50002C8.94773 21.5 8.50002 21.0523 8.50002 20.5C8.50002 19.9477 8.94773 19.5 9.50002 19.5H11V18.4381C7.82093 18.0418 5.22279 15.7805 4.33136 12.7852C4.17382 12.2559 4.47522 11.6991 5.00456 11.5415C5.5339 11.384 6.09073 11.6854 6.24827 12.2148C6.98609 14.6939 9.28339 16.5 11.9999 16.5C14.7165 16.5 17.0138 14.6939 17.7516 12.2148C17.9091 11.6854 18.466 11.384 18.9953 11.5415Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 10.5V7C14.5 5.61929 13.3807 4.5 12 4.5C10.6193 4.5 9.5 5.61929 9.5 7V10.5C9.5 11.8807 10.6193 13 12 13C13.3807 13 14.5 11.8807 14.5 10.5ZM12 2.5C9.51472 2.5 7.5 4.51472 7.5 7V10.5C7.5 12.9853 9.51472 15 12 15C14.4853 15 16.5 12.9853 16.5 10.5V7C16.5 4.51472 14.4853 2.5 12 2.5Z" fill="currentColor"></path></svg>
                      
                        )}

                        </span>

                      {/* Send icon on the right */}
                      <span onClick={(e) => {
                        if (formatterLoading) {
                            e.stopPropagation();
                            e.preventDefault();
                            return;
                         }
                          handleFormatterStart(studyId)
                        }}
                        title="Generate Report"
                        onMouseEnter={() => setIsSendButtHovering(true)}
                        onMouseLeave={() => setIsSendButtHovering(false)}

                        style={{ display: "inline-block", height: "30px", width: "35px", cursor: "pointer" }}
                      >
                        <svg

                          style={{
                            borderColor: "#5d5d5d",
                            backgroundColor: isSendButtHovering ? "#0a0000" : "transparent",
                            borderColor: "#5d5d5d",
                            color: "#5d5d5d",
                            border: "1px solid",
                            borderRadius: "35px",
                            width: "20px",
                            height: "20px",
                            padding: "5px",
                            marginLeft: "5px",
                            marginRight: "5px",
                            cursor: !formatterLoading ? "pointer" : "not-allowed",
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill={isSendButtHovering ? "white" : "#5d5d5d"}
                          viewBox="0 0 24 24"
                        >
                          <path d="M3.4 20.3l19.5-8.7c.5-.2.5-.9 0-1.1L3.4 1.8c-.4-.2-.9.1-.9.6v6.5c0 .3.2.6.5.7l11.2 2.4-11.2 2.4c-.3.1-.5.3-.5.7v6.5c0 .5.5.8.9.6z" />
                        </svg>
                      </span>

                    </div>
                  </div>
                </div>

              </div>

            </>
          </div>  </div>
      </div>
    </>
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={PrimaryButtonList}
        DefaultButtonList={DefaultButtonList}
        SecondaryButtonList={ToggleViewButton}
      />
    ),
    width: "1200px",
    height: "658px"
  };

  return (
    <>
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={showFormatterPopupClipped}
      />
    </>
  );
};

export default FormatterAgentClippedModal;


const AddTab = (props) => {
  const { getThemeColor, themeName } = useContext(themeContext);
  const [dtReportTemplatesId, setDtReportTemplatesId] = useState([]);
  const [rsnaReportTemplateId, setRsnaReportTemplatesId] = useState([]);
  const [radioReportTemplateId, setRadioReportTemplatesId] = useState([]);
  const [dsrReportTemplateId, setDsrReportTemplateId] = useState([]);
  const { patientReports, setAlertSuccessModal, alertSuccessModal, isClientReportExist, allReportTemplates, allowCopyPaste, isRestrictionsEnabled, showFormatterPopupClipped, setShowFormatterPopupClipped, handleSaveReport } = useContext(studyReportContext);

  /*
  useEffect(()=>{

  },[allReportTemplates]) */

  const getRadiologistTemplateId = (reportData) => {
    if (reportData?.reportTemplateId == null || reportData?.reportTemplateId == undefined) {
      return reportData?.id;
    } else {
      return reportData?.reportTemplateId;
    }
  }

  return (<>
    <div className="table-report">
      <ul id="horizontal-list" style={{ minWidth: 'unset', display: 'none' }} >
        {props?.data?.map((report, index) => {
          return (
            <li
              onClick={() => {
                props.setActiveTabIndex(index);
                // props.handleChangeTemplate(report, index);
              }}
              id={report.key}
              key={index}
              className={
                index == props.activeTabIndex ? `${themeName}-active-li li-tab` : " li-tab"
              }
              style={{ background: getThemeColor('report-not-active-tab'), color: getThemeColor("primary-color") }}
            >
              <span>{"USG Report"/*report.text*/}</span>
              <span className="badge-icon-d">
                {report.text.includes(REPORT_TITLE.TUBERCULOSIS) && process.env.REACT_APP_VDC_PLATFORM == "false" ? <RBadge /> : radioReportTemplateId.includes(getRadiologistTemplateId(report.reportDetails)) ? <PBadge /> :
                  dtReportTemplatesId.includes(report.reportDetails?.reportTemplateId) ? <DBadge /> :
                    rsnaReportTemplateId.includes(report.reportDetails?.reportTemplateId) && process.env.REACT_APP_VDC_PLATFORM == "false" ? <RBadge /> :
                      isClientReportExist ? <CLBadge /> : dsrReportTemplateId.includes(report.reportDetails?.reportTemplateId) || dsrReportTemplateId.includes(report.reportDetails?.id) ? <LBadge /> : <DBadge />
                }
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  </>)
};

const LoaderBar = (props) => {

}
